export const getInvoiceHref = (itemId: string | null, skuId?: string | null): string => {
    const qp = skuId ? `?skuId=${skuId}` : '';
    return `/orders/invoice/id-${itemId}${qp}`;
};
